import { SxProps, Theme } from '@mui/material/styles';
import { FC } from 'react';
import { useQuery } from 'react-query';
import { Service } from 'src/models/appointment/_types';
import { fetchServices } from 'src/models/appointment/appointment';

import { BaseSelect, SelectProps, createFormSelect } from './BaseSelect';

type ServiceSelectProps = Omit<SelectProps, 'options' | 'loading'> & {
  sx?: SxProps<Theme>;
};

export const ServiceSelect: FC<ServiceSelectProps> = (props) => {
  const { data: services = [], isLoading } = useQuery<Service[]>({
    queryKey: ['services'],
    queryFn: () => fetchServices({ includePrivate: true }),
    staleTime: 60000,
    cacheTime: 60000,
  });

  const options = services.map((service) => ({
    id: service.id,
    label: service.name,
  }));

  return <BaseSelect {...props} options={options} loading={isLoading} />;
};

export const FormServiceSelect = createFormSelect(ServiceSelect);
